import { useEffect, useState } from 'react'

import { Box, Slider, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const FloorsSlider = styled(Slider)(({ theme }) => ({
  height: 2,
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 4px rgba(58, 133, 137, 0.16)',
    },
    '&:active': {
      boxShadow: '0 0 0 6px rgba(58, 133, 137, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    height: 2,
  },
  '& .MuiSlider-rail': {
    color: '#d8d8d8',
    opacity: 1,
    height: 2,
    ...theme.applyStyles('dark', {
      color: '#bfbfbf',
      opacity: undefined,
    }),
  },
  '& .MuiSlider-valueLabel': {
    fontSize: 10,
    fontWeight: 'normal',
    top: 20,
    backgroundColor: 'unset',
    color: theme.palette.text.primary,
    '&::before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: '#000',
      ...theme.applyStyles('dark', {
        color: '#fff',
      }),
    },
  },
}))

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {number[]} props.value
 * @param {Object} props.availableFloors
 * @param {number} props.availableFloors.min
 * @param {number} props.availableFloors.max
 * @param {Function} props.onSave
 * @param {boolean} props.disabled
 */
export default function FloorsSelector({ value, onSave, availableFloors, disabled }) {
  const [innerValue, setInnerValue] = useState(value)

  useEffect(() => {
    setInnerValue(value)
  }, [value])

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      sx={{ maxWidth: 400, width: 1 }}
    >
      <Typography variant="body">Floors</Typography>
      <Box
        display="flex"
        sx={{
          border: 1,
          borderRadius: 1,
          borderColor: '#e0e0e0',
          px: 2,
          py: 0.5,
          mt: 1,
        }}
      >
        <FloorsSlider
          disableSwap
          disabled={disabled}
          min={availableFloors?.min ?? 1}
          max={availableFloors?.max ?? 1}
          valueLabelDisplay="on"
          value={innerValue}
          onChange={(_, val) => setInnerValue(val)}
          onChangeCommitted={(_, val) => onSave(val)}
        />
      </Box>
    </Box>
  )
}
